import * as React from "react";
const SvgDot01 = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={12} cy={12} r={8} fill="currentColor" /></svg>;
export default SvgDot01;